export { ComposedHighlightToolbar } from './ComposedHighlightToolbar';
export { ComposedHighlightStyles } from './styled';
